<script>
export default {
  name: "Password",
  props:{
    visible:{
      type:Boolean,
      default: false
    }
  },
  data(){
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      show:false,
      form:{
        oldPassword:"",
        password:"",
        confirmPassword:""
      },
      rules:{
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
      }
    }
  },
  watch:{
    visible(val){
      console.log("切换显示",val)
      this.show = val
    }
  },
  methods:{
    handleClose(){
      console.log("关闭")
      this.show = false
      this.form.oldPassword = ''
      this.form.password = ''
      this.form.confirmPassword = ''
      this.$emit('update:visible',false)
    },
    handleSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log('form',this.form)
          this.$cloud.post('/account/password',this.form).then(() => {
            this.$message.success("修改成功")
            this.handleClose()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<template>
  <el-dialog title="修改密码" :visible.sync="show" @close="handleClose" width="400px">
    <el-form class="m-2 pb-2 pl-4 pr-4" ref="form" status-icon :model="form" :rules="rules" label-width="110px">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input v-model="form.oldPassword" type="password" placeholder="请输入旧密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" type="password" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" placeholder="请再次输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="" prop="">
        <el-button type="primary" @click="handleSubmit">修改</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<style scoped>

</style>
